import type { OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'

export function shouldAutoScrollToFilters(
  isFixedFlashLengthOfStayEnabled: boolean,
  previousFilter: OfferPageFilterType | undefined,
  activeFilter: OfferPageFilterType | undefined,
) {
  return isFixedFlashLengthOfStayEnabled ? !previousFilter && !!activeFilter : !!activeFilter
}
